import React from 'react'
import styled from '@emotion/styled'
import { ActionItem, SplitButtonDropdown, SplitButtonType } from 'view/components/menus'
import { downloadUrl } from 'utils'
import tradingEntityAssignmentUploadTemplateUrl from './upload/TradingEntityAssignment.xlsx'
import { Locale, Translation } from 'locale'

interface FundAssignmentDialogToolbarProps {
  onShowFundAssignmentDialogModal: () => void
}

const SplitButtonStyled = styled(SplitButtonDropdown)`
  max-width: 90px;
`

const FundAssignmentDialogToolbarComponent: React.FunctionComponent<FundAssignmentDialogToolbarProps> = ({
  onShowFundAssignmentDialogModal
}) => {
  const handleDownloadFundAssignmentDialogSpreadsheet = () =>
    downloadUrl(tradingEntityAssignmentUploadTemplateUrl, Locale.translate(Translation.TC_TRADING_ENTITY_ASSIGN_UPLOAD_TEMPLATE_FILENAME))

  const toolbarActions: ActionItem[] = [
    {
      buttonLabel: Locale.translate(Translation.TC_TRADING_ENTITY_ASSIGN_UPLOAD_UPLOAD_BUTTON_LABEL),
      label: Locale.translate(Translation.TC_TRADING_ENTITY_ASSIGN_UPLOAD_UPLOAD_DROPDOWN_LABEL),
      type: SplitButtonType.Primary,
      onClick: onShowFundAssignmentDialogModal,
      enabled: true
    },
    {
      label: Locale.translate(Translation.TC_TRADING_ENTITY_ASSIGN_UPLOAD_DOWNLOAD_SPREADSHEET),
      type: SplitButtonType.Primary,
      onClick: handleDownloadFundAssignmentDialogSpreadsheet,
      enabled: true
    }
  ]

  return (
    <SplitButtonStyled
      dataTestId={'FundAssignmentDialogToolbar-TextButton-ButtonNewTradingEntity'}
      actions={toolbarActions}
      maxButtons={1}
    />
  )
}

export const FundAssignmentDialogToolbar = FundAssignmentDialogToolbarComponent
